import { getNameById } from "components/form/CommonInputs";
import _ from "lodash";
import { extractValue, safeValue, formatDateForAPI } from "./helper";
import { DEFAULT_LANG, LANG } from "constants/constants";

export const getErrorMessage = (apiErrorResponse, watch) => {
  if (apiErrorResponse?.["email"]) {
    return "api_error_email_duplicate";
  } else if (watch("email") === "") {
    return "mandatory_input";
  }
  return "api_error_email_invalid";
};

export const formatReceivedData = ({
  data,
  branches,
  usersByIds,
  namesByFilters,
}) => ({
  ...data,
  branch_id: getNameById({ list: branches, id: data.branch_id }),
  assigned_branches: branches
    .filter((elm) => data?.assigned_branches?.includes(elm.id))
    .map((elm) => ({
      value: elm.id,
      label: elm.name,
    })),
  manager_id: getNameById({ list: namesByFilters, id: data?.manager_id }),
});

export const getLastMissionStartDate = (list) =>
  _.chain(list)
    .sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
    .first()
    .get("start_date")
    .value();

export const formatCreatedData = (data) => {
  const user = {
    email: data.personal_email || data.email,
    picture_file_id: safeValue(data.picture_file_id),
    role: ["ROLE_USER"],
    user_language: DEFAULT_LANG.FR,
  };

  const person = {
    comment: safeValue(data.comment),
    dav_function: "str",
    first_name: data.first_name,
    gender: data.gender,
    last_name: data.last_name,
    phone_number: safeValue(data.phone_number),
    profile_id: "str",
    site_language: LANG.FR,
    school: "School",
    school_level: "level_five",
  };

  const worker = {
    sigle: "AZF",
    status: "status_one",
  };

  const subcontractor = {
    begin_contract_date: formatDateForAPI(new Date()),
    branch_id: extractValue(data.branch_id),
    company_comment: safeValue(data.company_comment),
    currency_id: extractValue(data.currency_id),
    payment_deadline: data.payment_deadline,
    remuneration_comment: safeValue(data.remuneration_comment),
    remuneration_other: safeValue(data.remuneration_other),
    remuneration_tarification: Number(data.remuneration_tarification) || 0,
    remuneration_type: data.remuneration_type || "tarification",
  };

  const history_manager = {
    establishment_date: formatDateForAPI(new Date()),
    manager_id: extractValue(data.manager_id),
    branch_id: extractValue(data.branch_id),
  };

  return {
    user,
    person,
    worker,
    subcontractor,
    history_manager,
  };
};
